define('modules/salesforce/drawer/views/base.salesforce.drawer',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/base/drawer/views/base.integration.drawer',
    'text!modules/salesforce/drawer/templates/base.salesforce.drawer.template.html'
], function(
    Prospector,
    $, _,Backbone,
    BaseIntegrationDrawer,
    Template
){
    var BaseSalesforceDrawer = BaseIntegrationDrawer.extend({
        className: 'salesforceDrawer',
        template: _.template(Template),
        sessionCheckProperty: 'hasActiveSFSession',
        buildModel:function(){
            this.model = window.salesforceSession;
        },
        menuPopup: function(){
            if(window.location.href.indexOf("person") > -1){ // If current profile page is of a person
                if ($('.popMenu').is(":visible")) {
                    $('.popMenu').toggle('slide');
                }
            }

            if(window.location.href.indexOf("organization") > -1){// If current profile page is of a Organization
                if ($('.popMenu2').is(":visible")) {
                    $('.popMenu2').toggle('slide');
                }
            }
        },
        passActiveSession:function(){
            window.utils.eraseCookie('SFDCSuccessLink');
        }
    });
    return BaseSalesforceDrawer;
});
